"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));

var _react = _interopRequireDefault(require("react"));

var _tippy = _interopRequireDefault(require("tippy.js"));

var _layout = _interopRequireDefault(require("./layout"));

var ToolTipContainer = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(ToolTipContainer, _React$Component);

  var _super = (0, _createSuper2["default"])(ToolTipContainer);

  function ToolTipContainer(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, ToolTipContainer);
    _this = _super.call(this, props);

    _this.componentDidMount = function () {
      var placement = _this.props.placement;
      _this.tippy = (0, _tippy["default"])(_this.childrenRef.current, {
        theme: 'liva',
        content: _this.contentRef.current,
        placement: placement,
        arrow: true,
        onShow: _this.onShow,
        appendTo: _this.rootRef.current
      });
    };

    _this.componentWillUnmount = function () {
      if (_this.tippy) {
        _this.tippy.destroy();
      }
    };

    _this.onShow = function (instance) {
      var onShow = _this.props.onShow;
      onShow(function () {
        // Align tooltip to content size, so tooltip still appears at the specified placement
        instance.setContent(_this.contentRef.current);
      });
    };

    _this.render = function () {
      return /*#__PURE__*/_react["default"].createElement(_layout["default"], Object.assign({}, _this.props, {
        rootRef: _this.rootRef,
        contentRef: _this.contentRef,
        childrenRef: _this.childrenRef
      }));
    };

    _this.rootRef = _react["default"].createRef();
    _this.childrenRef = _react["default"].createRef();
    _this.contentRef = _react["default"].createRef();
    return _this;
  }

  return ToolTipContainer;
}(_react["default"].Component);

ToolTipContainer.defaultProps = {
  placement: 'top',
  onShow: function onShow() {}
};
var _default = ToolTipContainer;
exports["default"] = _default;